<template>
    <div id="propertyAdd">
        <van-form ref="form" @submit="onSubmit" label-width="110px" input-align="right">
            <van-field required v-model="form.name" name="name" label="姓名" placeholder="点击填写" :rules="[{ required: true, message: '请填写姓名' }]" />
            <van-field required name="性别" label="性别">
                <template #input>
                    <van-radio-group v-model="form.sex" direction="horizontal">
                        <van-radio :name="1">男</van-radio>
                        <van-radio :name="0">女</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field required v-model="form.phone" type="tel" name="phone" label="手机号" placeholder="点击填写" maxlength="11" :rules="[{ required: true, message: '请填写手机号' },{ validator :validPhone, message: '请输入正确手机号' }]" />
            <van-field readonly required clickable name="idType" :value="idTypeList[form.idType-1]" label="证件类型" placeholder="点击选择>" @click="showIdType = true" :rules="[{ required: true, message: '请选择证件类型' }]" />
            <van-field required v-model="form.idNo" type="text" name="idNo" label="证件号码" placeholder="点击填写" :rules="[{ required: true, message: '请填写证件号码' },{ validator :validIdNo, message: '请输入正确的身份证' }]" />
            <van-field v-model="form.email" name="email" type="email" label="邮箱" placeholder="点击填写" />
            <van-field v-model="form.address" rows="2" autosize label="地址" type="textarea" maxlength="50" placeholder="请输入地址" show-word-limit />
            <van-field v-model="form.contactName" name="contactName" label="紧急联系人姓名" placeholder="点击填写" />
            <van-field readonly clickable name="contactRelation" :value="contactList[form.contactRelation-1]" label="紧急联系人关系" placeholder="点击选择>" @click="showContact = true" />
            <van-field v-model="form.contactPhone" name="contactPhone" type="tel" label="紧急联系人电话" placeholder="点击填写" maxlength="11" />
            <van-field v-model="form.remark" rows="2" autosize label="备注" type="textarea" maxlength="50" placeholder="请输入备注" show-word-limit />
            <div style="height:1.2rem"></div>
            <div class="btn">
                <van-button round block type="primary" :loading="saveLoad" :disabled="saveLoad" native-type="submit">保存</van-button>
            </div>
        </van-form>
        <!-- 证件类型 -->
        <van-popup v-model="showIdType" position="bottom">
            <van-picker show-toolbar :columns="idTypeList1" @confirm="(item,index) => { form.idType = item.value;showIdType=false;$refs.form.resetValidation('idNo')}" @cancel="showIdType = false" />
        </van-popup>
        <!-- 紧急联系人关系 -->
        <van-popup v-model="showContact" position="bottom">
            <van-picker show-toolbar :columns="contactList" @confirm="(item,index) => { form.contactRelation = index/1+1;showContact=false }" @cancel="showContact = false" />
        </van-popup>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { validPhone, validEmail, validIdNo } from "@/utils/validate";
import {
    requestPropertyCreate,
    requestPropertyChange,
    requestPropertyDetail,
} from "@/api";
export default {
    name: "propertyAdd",
    data() {
        return {
            form: {
                name: "",
                sex: 1,
                phone: "",
                idType: "",
                idNo: "",
                address: "",
                email: "",
                contactName: "",
                contactRelation: "",
                contactPhone: "",
                remark: "",
            },
            saveLoad: false,
            showIdType: false,
            showContact: false,
            idTypeLists: ["身份证", "港澳台通行证", "护照"],
                idTypeList1: [{
            value: "1",
            text: "身份证"
        },
        {
            value: "2",
            text: "港澳通行证"
        },
        {
            value: "3",
            text: "护照"
        },
        {
            value: "7",
            text: "台湾通行证"
        },
       
        {
            value: "8",
            text: "营业执照"
        },
        {
            value: "5",
            text: "其他"
        }
    ],
            // idTypeList:['居民身份证','护照','港澳台居民身份证','旅行证据','其他'],//1:居民身份证，2:护照，3:港澳台居民身份证，4:旅行证据，5:其他'
        };
    },
    computed: {
        ...mapState(["idTypeList", "contactList", "customerList"]),
    },
    created() {
        if (this.$route.query.id) {
            this.getDetail();
        }
    },
    mounted() {},
    methods: {
        getDetail() {
            const toast1 = this.$toast.loading({
                forbidClick: true,
                duration: 0,
                message: "加载中...",
            });
            requestPropertyDetail(this.$route.query.id)
                .then((res) => {
                    this.form = res.data.property;
                    toast1.clear();
                })
                .catch((err) => {
                    toast1.clear();
                });
        },
        //新增
        onSubmit() {
            this.saveLoad = true;
            if (this.$route.query.id) {
                //修改
                requestPropertyChange(this.form)
                    .then((res) => {
                        this.saveLoad = false;
                        this.$toast.success({
                            message: "修改成功",
                            forbidClick: true,
                            onClose: () => {
                                this.$router.back();
                            },
                        });
                    })
                    .catch((err) => {
                        this.saveLoad = false;
                        console.log(err);
                    });
            } else {
                //新增
                requestPropertyCreate(this.form)
                    .then((res) => {
                        this.saveLoad = false;
                        this.$toast.success({
                            message: "新增成功",
                            forbidClick: true,
                            onClose: () => {
                                this.$router.back();
                            },
                        });
                    })
                    .catch((err) => {
                        this.saveLoad = false;
                        console.log(err);
                    });
            }
        },
        validPhone(val) {
            return validPhone(val);
        },
        validEmail(val) {
            return validEmail(val);
        },
        validIdNo(val) {
            if (this.form.idType == 1) {
                return validIdNo(val);
            } else {
                return true;
            }
        },
    },
    watch: {},
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
.body {
    .remark {
        background: #fff;
        padding: 0.4rem 1rem;
        font-size: 0.35rem;
        text-align: left;
        border-bottom: 1px solid #ececec;
        textarea {
            border: none;
            width: 100%;
            margin-top: 0.2rem;
        }
    }
    .slot {
        .gender {
            * {
                vertical-align: text-bottom;
            }
        }
        .placeholder {
            color: #cccccc;
        }
    }
}
.btn {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    border-radius: 0.1rem;
    overflow: hidden;
    display: flex;
    /deep/.van-button {
        margin-left: -1px;
        border: none;
        border-radius: 0;
        flex: 1;
        &:not(:last-child)::after {
            height: 50%;
            position: absolute;
            box-sizing: border-box;
            content: " ";
            pointer-events: none;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            border-right: 0.02667rem solid #ebedf0;
            z-index: 99;
        }
    }
    .font4 {
        width: 2.4rem;
    }
    .font3 {
        width: 1.8rem;
    }
    .font5 {
        width: 51%;
    }
    .font1 {
        width: 100%;
        margin-left: 0;
    }
}
/deep/.van-field__error-message {
    text-align: right;
}
</style>
